import { BoardViewType } from "app/types";
import {
  CustomizeCardOptions,
  VisibleGroupsOptions,
} from "../components/CreateBoardsComponent/data";
import {
  BoardPermission,
  ContainerState,
  GroupByTypeEnum,
  ISelectedTickets,
  SubGroupEnum,
  TicketType,
} from "../types";

export const defaultSelectedTickets: ISelectedTickets = {
  id: [],
  group: [],
  status: [],
  assignee: [],
  releases: [],
  sprint: [],
  effortsEstimation: 0,
};
export const initialState: ContainerState = {
  boardsData: [],
  favorites: [],
  qaBoards: [],
  recent: [],
  boardsForm: {
    id: "",
    type: BoardViewType.LIST,
    name: "",
    projects: [],
    owner: {
      _id: "",
      name: "",
      online: false,
      color: "",
      role: "",
    },
    createdAt: "",
    lastUpdated: "",
    lastViewed: "",
    permission: BoardPermission.PRIVATE,
    description: "",
    ticketType: TicketType.BUG,
    subGroups: SubGroupEnum.NONE,
    visibleGroups: VisibleGroupsOptions,
    customizeCard: CustomizeCardOptions,
    groupsBy: GroupByTypeEnum.STATUS,
    defaultTicketValue: [],
    customPermissions: [],
  },
  defaultTicketValueData: {
    customFields: [],
    contextFields: [],
  },
  draftTicket: [],
  selectedTickets: { ...defaultSelectedTickets },
  selectedBoard: [],
  isFileUploading: false,
  isFilePreview: false,
  uploadProgress: 0,
  sortByColumn: "",
  sortByOrder: "",
  isLoading: false,
  isBulkExporting: false,
  boardLoading: false,
  enableTicketDescription: true,
  enableAddNewTemplateForm: false,
};
